const RunAfter = function (func, timeout) {
    setTimeout(() => {
        func();
    }, timeout);
};
export default RunAfter;
